import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { cn } from '../../utils/cn';
const Footer = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("footer", { ref: ref, className: cn('bg-white border-t border-gray-200', className), ...props }));
});
Footer.displayName = 'Footer';
export { Footer };
